/** @jsxImportSource react */
import { generateSelectOptionsWithLabelValue } from '@react/form/helpers/generateOptions';
import { string } from 'proptypes';
import React, { forwardRef, useCallback } from 'react';
import clsxm from 'sly/lib/clsxm';

// to-do check if correct colors are used
const Input = forwardRef(
  (
    {
      className,
      type = 'text',
      hideBorder,
      showIcon: _showIcon,
      invalid,
      ...props
    },
    ref
  ) => {
    const getClasses = useCallback(
      (props) => {
        if (props.disabled || props.readOnly) {
          return [
            'bg-slate-lighter-95',
            'border-slate-lighter-90',
            'text-slate-lighter-40',
          ];
        } else if (props.warning) {
          return [
            'bg-green-lighter-90',
            'text-white-base',
            'border-green-base',
          ];
        } else if (invalid) {
          return [
            'bg-red-lighter-90',
            'text-white-base',
            'border-red-lighter-60',
          ];
        } else {
          return [
            'bg-white',
            'border-slate-lighter-90',
            'focus:border-viridian-base',
          ];
        }
      },
      [props]
    );

    if (type === 'textarea') {
      return (
        <>
          <textarea
            className={clsxm(
              ...getClasses(props),
              'min-h-24 font-b-s m-0 block min-h-full w-full min-w-full rounded border',
              'focus:outline-none',
              hideBorder ? 'resize-none border-none p-0' : 'p-s',
              invalid && hideBorder ? '!p-s' : '',
              className
            )}
            {...props}
          />
          {props?.maxlength && (
            <div className='font-b-xs mt-1 text-right'>
              {props?.value?.length}/{props.maxlength}
            </div>
          )}
        </>
      );
    } else if (type === 'select') {
      return (
        <select
          className={clsxm(
            ...getClasses(props),
            'font-b-s m-0 block min-h-full w-full min-w-full rounded border p-s',
            // 'focus:outline-none',
            className,
            !props.value ? 'select-disabled-gray' : ''
          )}
          data-tp-id='gen-select-7ab17daa-26d6-45a9-9d0a-f00e5d559251'
          {...props}
          disabled={props.readOnly}
        >
          {props?.options && generateSelectOptionsWithLabelValue(props.options)}
        </select>
      );
    }
    return (
      <input
        data-tp-id='gen-input-ee711f4d-29d8-4397-a72f-becf0f0a61a4'
        ref={ref}
        className={clsxm(
          ...getClasses(props),
          'font-b-m block h-11 w-full rounded border  p-s',
          'focus:outline-none',
          className
        )}
        type={type}
        {...props}
        autoComplete='new-password'
      />
    );
  }
);

Input.propTypes = {
  className: string,
  type: string,
};

export default Input;
